var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStarOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_9043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54874 1.44568C6.72986 1.06612 7.27014 1.06612 7.45126 1.44568L8.61122 3.87657C8.68411 4.02933 8.82933 4.13484 8.99713 4.15696L11.6675 4.50896C12.0844 4.56392 12.2514 5.07776 11.9464 5.3673L9.99292 7.22168C9.87017 7.3382 9.8147 7.50892 9.84552 7.67535L10.3359 10.3238C10.4125 10.7373 9.97541 11.0549 9.60578 10.8543L7.23851 9.56945C7.08975 9.48871 6.91025 9.48871 6.76149 9.56945L4.39422 10.8543C4.02459 11.0549 3.5875 10.7373 3.66407 10.3238L4.15448 7.67535C4.1853 7.50892 4.12983 7.3382 4.00708 7.22168L2.05361 5.3673C1.7486 5.07776 1.91555 4.56392 2.33251 4.50896L5.00287 4.15696C5.17067 4.13484 5.31589 4.02933 5.38878 3.87657L6.54874 1.44568Z",
    fill: "black",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_9043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarOn);
export default __webpack_public_path__ + "static/media/icon_star_on.e1669d19f4eb6b842d7aeb83ffa705dc.svg";
export { ForwardRef as ReactComponent };